// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".async-error[data-v-26411077]{padding:calc(var(--fs-700)*3 + 116px) 0;width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.async-error>h2[data-v-26411077]{text-align:center}.async-error>.common-btn[data-v-26411077]{margin-top:var(--fs-700)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
